module.exports = __webpack_public_path__ + "static/media/icecream.cef45330.svg";